import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/location_new/miami/miami_back.webp";
import Bannerfrom from "../components/bannerfrom";

function Banner(props) {
  return (
    <div
      className="locationgcc_banner hosuton_banner no-bread-loc-banner"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={7} lg={7} xl={7} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                Mobile App Development Company <span>Miami</span>
              </h1>
              <p className="main_para">
                TekRevol is a leading mobile app development company in Miami,
                Florida offering a team of top app developers who’re always
                there to bring forth the best-in-class apps that fuel growth for
                your business. We aren’t just offering standalone application
                services. Our top management continues to keenly monitor the
                latest trends in the digital/tech space and can perfectly guide
                you in building your next million-dollar app idea.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={5} lg={5} xl={5} xxl={6} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
